// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._1e0c1bgi{display:contents}`, "",{"version":3,"sources":["webpack://./node_modules/@atlaskit/onboarding/dist/esm/components/node-resolver-spotlight-target.compiled.css"],"names":[],"mappings":"AAAA,WAAW,gBAAgB","sourcesContent":["._1e0c1bgi{display:contents}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
